import { rewriteImageSrc } from '@/utils/rewriteImageSrc';
import classNames from 'classnames';
import type { TAuthorAttributes } from '../Authors.type';

interface Props {
  imageUrl: string;
  alt?: string;
  className?: string;
  attributes: TAuthorAttributes;
}

const ALIGNMENT_OPTIONS = {
  left: 'ml-0 mr-auto',
  center: 'mx-auto',
  right: 'ml-auto mr-0',
};

const Image = ({ imageUrl, alt, className, attributes }: Props) => {
  const alignment: keyof typeof ALIGNMENT_OPTIONS = attributes?.alignment || ('left' as any);
  const alignmentClass = ALIGNMENT_OPTIONS[alignment] || 'mx-0';

  const style = {
    width: attributes?.portraitWidth || attributes?.imageSize || '16px',
    height: attributes?.portraitHeight || attributes?.imageSize || '16px',
    borderRadius: attributes?.imageRadius || '100px',
  };

  return (
    <img src={rewriteImageSrc(imageUrl)} alt={alt} className={classNames(alignmentClass, className)} style={style} />
  );
};

export default Image;
